import React from "react";
import "./SettingRow.scss";

/**
 * One row of a settings panel: a label with an optional grey caption on the
 * left, and a control on the right.
 *
 * Control-agnostic - the right-hand side is whatever you pass as children, so a
 * row can hold a toggle, a dropdown or a button.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.label     row heading
 * @param {React.ReactNode} [props.caption] grey sub-line; omitted when absent
 * @param {React.ReactNode} [props.children] the control rendered on the right
 * @param {string} [props.className]        appended to the root class
 */
const SettingRow = ({ label, caption, children, className = "" }) => (
  <div className={`shared-setting-row ${className}`.trim()}>
    <div className="shared-setting-row__text">
      <span className="shared-setting-row__label">{label}</span>
      {caption ? (
        <span className="shared-setting-row__caption">{caption}</span>
      ) : null}
    </div>

    {/* Rendered bare rather than inside a wrapper: children are the second flex
        item, so an extra div would change what space-between and
        align-items: flex-start act on. */}
    {children}
  </div>
);

export default SettingRow;
